import cx from 'classnames';
import React, { useMemo } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { View, ViewProps } from '../View/View';
import styles from './About.module.scss';

export interface AboutViewProps extends ViewProps {
  noPaddingTop?: boolean;
  background?: string;
  mobileAlignItems?: 'start' | 'end' | 'center' | 'stretch';
}

export const AboutView = ({
  noPaddingTop,
  leftPadding = 24,
  rightPadding = 36,
  children,
  className,
  background,
  style,
  mobileAlignItems = 'start',
  alignContent = 'center',
  justifyContent = 'center',
  maxWidth = 640,
  ...props
}: AboutViewProps) => {
  const { isMobile } = useAppContext();
  alignContent = isMobile ? mobileAlignItems : alignContent;
  const backgroundImage = useMemo(() => {
    if (!background) return undefined;
    return `url(/${background}${isMobile ? '' : '-lg'}.jpg)`;
  }, [isMobile, background]);
  return (
    <View
      {...{ justifyContent, alignContent, leftPadding, rightPadding }}
      className={cx(styles.view, !noPaddingTop && styles.viewPaddingTop, className)}
      style={{ ...style, backgroundImage }}
      {...props}
    >
      <View className={styles.viewContainer} maxWidth={maxWidth}>
        {children}
      </View>
    </View>
  );
};
